<section class="section-div">
  <div>
    <div class="d-flex justify-content-between">
      <div class="header-div">
        <h4 *ngIf="role != 'Preincubator'">
          <ion-icon name="grid-outline"></ion-icon> Application Dashboard -
          {{ incubaterName }}
        </h4>
        <h4 *ngIf="role == 'Preincubator'">
          <ion-icon name="grid-outline"></ion-icon> {{ incubName }}
        </h4>
      </div>
    </div>
    <div class="div-bg">
      <main>
        <div class="activity-container">
          <h6>No. of Questions Filled</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Questions
              <span
                >({{ dashboardData.questionsfilled }}/{{
                  dashboardData.totalquestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.notImplemented /
                    dashboardData.totalquestions) *
                  100
                "
                style="background-color: #56c2e6"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.questionsfilled / dashboardData.totalquestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Application Submission Status</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              <span *ngIf="dashboardData.status == 0">Pending</span>
              <span *ngIf="dashboardData.status == 1">Submitted</span>
              <span *ngIf="dashboardData.status == 2"
                >Process Verification</span
              >
              <span *ngIf="dashboardData.status == 3">Under Clarification</span>
              <span *ngIf="dashboardData.status == 4">Approved</span>
              <span *ngIf="dashboardData.status == 5">Rejected (Re-Apply)</span>
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>
            Remarks
            <span *ngIf="dashboardData.showBellIcon == true"
              ><img
                src="/assets/images/notification-bell-unscreen.gif"
                alt=""
                style="width: 25px"
            /></span>
          </h6>
          <p class="box-progress-header">
            <span>
              <a class="Clarification2-btn ml-3" (click)="History()">View</a>
            </span>
          </p>
        </div>
      </main>
      <div
        *ngIf="role == 'Admin' && dashboardData.status == 1"
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('2')">
          Process Verification
        </button>
        <button class="Clarification-btn ml-3" (click)="Clarification('3')">
          More Clarification
        </button>
      </div>
      <div
        *ngIf="role == 'Admin' && dashboardData.status == 3"
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('1')">
          Clarification Cleared, Mark as Resolved
        </button>
      </div>
      <div
        *ngIf="role == 'Admin' && dashboardData.status == 2"
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('4')">Approve</button>
        <button class="Clarification-btn ml-3" (click)="Clarification('5')">
          Reject
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Modal -->
<div class="modal-con">
  <div
    class="modal fade"
    id="Verfication"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="incubatee-div-modal">
          <div>
            <h3>Confirm</h3>
          </div>
          <div class="text-center mt-3">
            <button mat-raised-button color="warn">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
